import React from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../common/Button";

const Header = ({ amplitudeCall }) => {

  const history = useHistory();

  const { t } = useTranslation();

  const handlePage = () => {
    amplitudeCall(null, 'close');
    history.goBack();
  };

  return (
    <div className="header">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <h1 className="tit">{ t( 'LC_05_13.msg001' ) }</h1>
            <Button className="btn-close-wrap" onClick={handlePage}>닫기</Button>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Header;
